import { Box, Typography, Card, useTheme, Button } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { formatDateTimeForDisplay, hours } from '../../utils/exam-utilities'
import { Icons, EXAM_CARD_COLORS, getTransformedGroupDetails } from '../../utils/utilities'
import DataLoadingSpinner from '../common/DataLoadingSpinner'
import { useUserStore } from '../../store/user.store'
import { useExamStore } from '../../store/exam.store'
import noTasksImg from '../../assets/noexams.svg'
import CountBadge from '../common/CountBadge'
import { observer } from 'mobx-react'
import CustomChip from '../common/CustomChip'

const CurrentOrRecentExamsCard = observer( ( { title, subject } ) => {


    const [isExamsLoaded, setIsExamsLoaded] = useState( false )

    const ExamStore = useExamStore()
    const UserStore = useUserStore()

    const { theme, palette, border } = useTheme()

    const getExams = useCallback( async () => {
        if ( ExamStore.getErrors.pendingExams )
            await ExamStore.fetchPendingExams( subject ? subject.subject_id : undefined )
        setIsExamsLoaded( true )
    }, [ExamStore, subject] )


    useEffect( () => {
        const getData = () => {
            getExams()
        }
        getData()
    }, [getExams] )

    return (
        <Box gridArea="cre" display="flex" minWidth={0} minHeight="400px" flexDirection="column">
            <Box marginBottom="5px" height="25px" display="flex" justifyContent="space-between" gap="10px" alignItems="center">
                <Link className='default-link' to={UserStore.getUser["user_role"] === "STUDENT" ? `/student/exams` : `/faculty/exams`}>
                    <Typography sx={{ ":hover .redirect-arrow": { transform: "translate(2px,-2px)", color: "primary.main" } }} variant='subtitle2' display="flex" gap="5px" alignItems="center" component="h3" flexGrow={1}>
                        <Typography component="span" display="flex" alignItems="center" color='primary' >{Icons.default.QuizIconOutlined}</Typography>
                        Recent Exams
                        <Typography component="span" color='textSecondary' className='redirect-arrow' display="flex" alignItems="center">{Icons.default.ArrowOutward}</Typography>

                        {/* {ExamStore.getPendingExams.length > 0 && <CountBadge value={ExamStore.getPendingExams.length} />} */}
                    </Typography>
                </Link>
                {/* <Button size="small" sx={{ fontSize: "12px", borderRadius: "20px", padding: "1px 5px" }} variant='contained' color='customThemeColor' disableElevation>
                        View all
                    </Button> */}
            </Box>

            <Card elevation={0} sx={{ flexGrow: 1, border: border[1] }}>
                <Box display="flex" height="100%" overflow="auto" flexDirection="column">
                    {isExamsLoaded && ExamStore.getPendingExams.length > 0 && <Box className='custom-scrollbar' padding="5px" overflow="auto" gap="10px" display="flex" justifyContent="flex-start" flexDirection="column">
                        {ExamStore.getPendingExams.map( ( exam, index ) => {

                            const [hours, minutes] = exam.exam_duration?.split( ":" ).map( item => +item )
                            const hourStr = `${hours ? hours > 1 ? `${hours} hours` : `1 hour` : ""}`
                            const minuteStr = `${minutes ? `${minutes} minutes` : ""}`
                            const durationStr = `${hourStr}${hourStr ? ` ${minuteStr}` : minuteStr}`


                            let accessGroups = exam.batches_ids
                            if ( UserStore.getUser.user_role !== "STUDENT" ) {
                                accessGroups = accessGroups.map( groupId => {
                                    const group = UserStore.getUsersAllBatchesAndSectionList.find( item => String( item.id ) === String( groupId ) )

                                    if ( group )
                                        return getTransformedGroupDetails( group )
                                    return { id: groupId, chip_label: groupId }
                                } )
                            }


                            return (
                                <Link key={exam.exam_id} className='default-link' to={UserStore.getUser["user_role"] === "STUDENT" ? `/student/exams/${exam.exam_id}` : `/faculty/exams/${exam.exam_id}`}>
                                    <Box border={border[1]} sx={{ borderRadius: "5px", alignItems: "flex-start", display: "flex", gap: "10px", padding: "10px", cursor: "pointer", transition: "0.1s ease", ":hover": { bgcolor: palette.rowHover } }}>
                                        <Box marginTop="5px" fontSize="16px">{Icons.default.FiberManualRecordIcon}</Box>
                                        <Box flexGrow={1} overflow="hidden">
                                            <Typography width="100%" title={exam.name} noWrap fontSize="14px" textTransform="capitalize" fontWeight="500" >{exam.exam_name}</Typography>

                                            <Box display="flex" gap="5px" flexWrap="wrap" alignItems="center">
                                                {UserStore.getUser.user_role === 'STUDENT' && <CustomChip tooltipTitle='Conducted by' startIcon={Icons.default.User} value={exam?.created_by_data?.employee_name || exam?.created_by_data?.name || exam.created_by} />}
                                                {exam?.subject?.subject_name && <CustomChip tooltipTitle={`For subject: ${exam?.subject?.subject_name}`} value={exam?.subject?.subject_code} startIcon={Icons.default.Subjects} />}
                                                {exam?.subject?.subject_name && <CustomChip tooltipTitle='Starts at' value={formatDateTimeForDisplay( exam.exam_start_date, exam.exam_start_time )} startIcon={Icons.default.Calendar} />}
                                                {exam?.exam_duration && <CustomChip tooltipTitle='Exam duration' value={durationStr} startIcon={Icons.default.Clock} />}
                                                {UserStore.getUser.user_role !== 'STUDENT' && accessGroups.length > 0 && accessGroups.map( group => (
                                                    <CustomChip key={group.id} value={group.chip_label} tooltipTitle={group.academic_details} />
                                                ) )}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Link>
                            )
                        } )
                        }
                    </Box>}
                    {( !isExamsLoaded ) && <Box display="flex" justifyContent="center">
                        <DataLoadingSpinner />
                    </Box>}
                    {isExamsLoaded && ExamStore.getPendingExams.length === 0 && <Box height="100%" padding="20px" display="flex" flexGrow={1} alignItems="center" flexDirection="column" gap="20px" justifyContent="center">
                        <img width="150px" src={noTasksImg} alt="No pending tasks" />
                        <Typography variant="subtitle2">Relax no upcomming exams!</Typography>
                    </Box>}
                </Box>
            </Card>
        </Box>

    )
} )

export default CurrentOrRecentExamsCard
